import React from 'react';
import Icon from '../../../components/AppIcon';

const ConnectionStatus = ({ isConnected, lastUpdate }) => {
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })?.format(date);
  };

  return (
    <div className="flex items-center gap-3 md:gap-4">
      <div className={`
        flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium
        ${isConnected 
          ? 'bg-success/10 text-success' :'bg-error/10 text-error'
        }
      `}>
        <div className={`w-2 h-2 rounded-full ${isConnected ? 'bg-success' : 'bg-error'} animate-pulse`} />
        <span className="hidden md:inline">{isConnected ? 'Live' : 'Disconnected'}</span>
      </div>
      
      {isConnected && lastUpdate && (
        <div className="hidden lg:flex items-center gap-2 text-xs text-muted-foreground caption">
          <Icon name="RefreshCw" size={12} />
          <span>Updated {formatTime(lastUpdate)}</span>
        </div>
      )}
    </div>
  );
};

export default ConnectionStatus;